import React, { useState, useEffect } from "react";

import minusImage1 from "../../Images/minusImage1.png";
import plusImage1 from "../../Images/plusImage1.png";
import deleteImage from "../../Images/deleteImage.png";
import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";
import shoppingbag from "../../Images/shoppingbag.png";
import axios from "axios";
import CloseImg from "../../Images/CloseImg.png";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import { Class } from "@mui/icons-material";
import { useLocation, useParams } from "react-router-dom";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

export default function AllCategoriesFiltersSearchPage({
  setProductsDataWithoutDub,
  setProductsData,
  onToggle,
  MyBrandsFilter,
  open3,
  setOpen3,
  sendDataToParent,
  dataFromChild,
  onButtonClick,
  data,
  content,
  showContent,
  clearAll,
  sendPricingToParent,
  delPricing,
}) {
  const { t, i18n } = useTranslation();
  const [selectedPriceRange, setSelectedPriceRange] = useState(null); // State for selected price range
  const [customMinPrice, setCustomMinPrice] = useState(""); // State for custom min price
  const [customMaxPrice, setCustomMaxPrice] = useState(""); // State for custom max price
  const [items, setItems] = useState([]);
  const [TheObject, setTheObject] = useState({});
  const handleClick = (data) => {
    sendDataToParent(data); // Sending data to parent
  };

  React.useEffect(() => {
    setSelectedPriceRange(null); // Deselect
    setCustomMinPrice(""); // Reset custom price inputs
    setCustomMaxPrice("");
    applyFilters(
      BrandsFilter,
      GenderFilter,
      TopNoteFilter,
      ProductTypeFilter,
      ClassficationFilter,
      ProductPropertiesFilter,
      ScentTypeFilter,
      HeartNoteFilter,
      BaseNoteFilter,
      IngredientsFilter,
      SpecialCertificatesFilter,
      VolumeFilter,
      MadeInFilter,
      ColorFilter,
      ProductPropertiesFilter,
      EyeshadowEffectFilter,
      FormulaFilter,
      CountryFilter,
      HairTypeFilter,
      BrushMaterialFilter,
      SkinTypeFilter,
      AgeFilter,
      0,
      Infinity
    );
    if (delPricing) {
      console.log("When delPricing True:", delPricing);
    } else {
      console.log("When delPricing False:", delPricing);
    }
  }, [delPricing]);

  React.useEffect(() => {
    if (content) {
      handleCheckboxChangeForAll(content.filter, content.id);
    }
  }, [content]);
  handleClick(items);

  React.useEffect(() => {
    if (clearAll) {
      ClearButton();
    }
  }, [clearAll]);
  // Function to add a new object to the array
  const addItem = () => {
    // Update the state by appending the new item to the existing array
    setItems([...items, TheObject]);
  };

  // Log the data passed from the parent
  React.useEffect(() => {
    if (data) {
      //handleCheckboxChangeForAll("BrandsFilter", 1);
    }
  }, [data]);

  // Function to handle toggling or setting the `open` state from the child
  const handleToggleFromChild = (value) => {
    ShowApplyFunc(false);
    if (typeof value === "boolean") {
      setOpen3(value); // Set the state to the provided value (true or false)
    } else {
      setOpen3((prevOpen) => !prevOpen); // Toggle the state if no value is provided
    }
  };

  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //const [ProductsDataWithoutDub, setProductsDataWithoutDub] = useState([]);
  const [ProductsDataWithoutDub2, setProductsDataWithoutDub2] = useState([]);
  const [ShowTopSection, setShowTopSection] = useState(true);

  const handleClick2 = (minPrince, maxPrice) => {
    const isValidNumber = (value) => {
      return value !== null && value !== "" && !isNaN(value);
    };

    // Check if both values are valid
    const isMinValid = isValidNumber(minPrince);
    const isMaxValid = isValidNumber(maxPrice);

    // If both values are valid, send them; otherwise, send empty strings
    if (isMinValid && isMaxValid) {
      sendPricingToParent({ min: Number(minPrince), max: Number(maxPrice) });
    } else {
      sendPricingToParent({ min: "", max: "" }); // Send empty strings if either value is invalid
    }
  };
  //const [ProductsData, setProductsData] = useState([]);
  const [TitleName, setTitleName] = useState("");

  useEffect(() => {
    const fetchSearchResults = async () => {
      setProductsData([]);
      // 1. Get the current URL and extract the 'q' parameter
      const urlObj = new URL(window.location.href);
      const encodedSearchTerm = urlObj.searchParams.get("q"); // "Dolce%20&%20Gabbana"

      // 2. Decode it to human-readable format (optional, only if you need to display it)
      const decodedSearchTerm = decodeURIComponent(encodedSearchTerm || ""); // "Dolce & Gabbana"
      // 3. Make the API call with the ORIGINAL encoded term
      if (encodedSearchTerm) {
        try {
          const response = await axios.get(
            `${MyDomain}Products/GetProductsSearchPage/?q=${encodedSearchTerm}`
          );
          setProductsData([]);

          setProductsData(response.data.products); // Store the data
          const newArray = response.data.products.filter(
            (item) => item.id === item.productId
          );
          groupAndSetFilter(newArray, "brand", setBrandsFilter);
          groupAndSetFilter(newArray, "gender", setGenderFilter);
          groupAndSetFilter(newArray, "topNote", setTopNoteFilter);
          groupAndSetFilter(newArray, "productType", setProductTypeFilter);
          groupAndSetFilter(newArray, "classfication", setClassficationFilter);
          groupAndSetFilter(
            newArray,
            "productProperties",
            setProductPropertiesFilter
          );
          groupAndSetFilter(newArray, "scentType", setScentTypeFilter);
          groupAndSetFilter(newArray, "heartNote", setHeartNoteFilter);
          groupAndSetFilter(newArray, "baseNote", setBaseNoteFilter);
          groupAndSetFilter(newArray, "ingredients", setIngredientsFilter);
          groupAndSetFilter(
            newArray,
            "specialCertificates",
            setSpecialCertificatesFilter
          );
          groupAndSetFilter(newArray, "volume", setVolumeFilter);
          groupAndSetFilter(newArray, "madeIn", setMadeInFilter);
          groupAndSetFilter(newArray, "color", setColorFilter);
          groupAndSetFilter(
            newArray,
            "protectionLevel",
            setProtectionLevelFilter
          );
          groupAndSetFilter(
            newArray,
            "eyeshadowEffect",
            setEyeshadowEffectFilter
          );
          groupAndSetFilter(newArray, "formula", setFormulaFilter);
          groupAndSetFilter(newArray, "country", setCountryFilter);
          groupAndSetFilter(newArray, "hairType", setHairTypeFilter);
          groupAndSetFilter(newArray, "brushMaterial", setBrushMaterialFilter);
          groupAndSetFilter(newArray, "skinType", setSkinTypeFilter);
          groupAndSetFilter(newArray, "age", setAgeFilter);

          setProductsDataWithoutDub(newArray);
          setProductsDataWithoutDub2(newArray);
          setTitleName("");
          //setProducts(response.data);
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      }
    };

    fetchSearchResults();
  }, []);

  const groupAndSetFilter = (array, key, setFilter) => {
    // Filter and clean up the array before processing
    const nonEmptyArray = array.filter((item) => item[key]?.trim() !== "");

    if (nonEmptyArray.length === 0) {
      setFilter([""]); // Set to an array containing an empty string if all are empty
      return;
    }

    const groupedData = Object.values(
      nonEmptyArray.reduce((acc, item) => {
        // Split the key value by comma and trim whitespace
        const parts = item[key]?.split(",").map((part) => part.trim()) || [];

        parts.forEach((value) => {
          if (!acc[value]) {
            acc[value] = {
              id: Object.keys(acc).length + 1,
              [key]: value,
              times: 0,
              checked: false,
            };
          }
          acc[value].times += 1;
        });

        return acc;
      }, {})
    );
    setFilter(groupedData);
  };

  const [hideBrandFilter, setHideBrandFilter] = useState(true);
  const [hideGenderFilter, setHideGenderFilter] = useState(false);
  const [hideTopNoteFilter, setHideTopNoteFilter] = useState(false);
  const [hideProductTypeFilter, setHideProductTypeFilter] = useState(true);
  const [hideClassfication, setHideClassfication] = useState(false);
  const [hideProductProperties, setHideProductProperties] = useState(true);
  const [hideScentType, setHideScentType] = useState(false);
  const [hideHeartNote, setHideHeartNote] = useState(false);
  const [hideBaseNote, setHideBaseNote] = useState(false);
  const [hideIngredients, setHideIngredients] = useState(false);
  const [hideSpecialCertificates, setHideSpecialCertificates] = useState(false);
  const [hideVolume, setHideVolume] = useState(false);
  const [hideMadeIn, setHideMadeIn] = useState(false);
  const [hideColor, setHideColor] = useState(false);
  const [hideProtectionLevel, setHideProtectionLevel] = useState(false);
  const [hideEyeshadowEffect, setHideEyeshadowEffect] = useState(false);
  const [hideFormula, setHideFormula] = useState(false);
  const [hideCountry, setHideCountry] = useState(false);
  const [hideHairType, setHideHairType] = useState(false);
  const [hideBrushMaterial, setHideBrushMaterial] = useState(false);
  const [hideSkinType, setHideSkinType] = useState(false);
  const [hideAge, setHideAge] = useState(false);
  const [hidePrice, setHidePrice] = useState(true);

  /////
  const [BrandsFilter, setBrandsFilter] = useState([]);
  const [GenderFilter, setGenderFilter] = useState([]);
  const [TopNoteFilter, setTopNoteFilter] = useState([]);
  const [ProductTypeFilter, setProductTypeFilter] = useState([]);
  const [ClassficationFilter, setClassficationFilter] = useState([]);
  const [ProductPropertiesFilter, setProductPropertiesFilter] = useState([]);
  const [ScentTypeFilter, setScentTypeFilter] = useState([]);

  const [HeartNoteFilter, setHeartNoteFilter] = useState([]);
  const [BaseNoteFilter, setBaseNoteFilter] = useState([]);
  const [IngredientsFilter, setIngredientsFilter] = useState([]);
  const [SpecialCertificatesFilter, setSpecialCertificatesFilter] = useState(
    []
  );
  const [VolumeFilter, setVolumeFilter] = useState([]);
  const [MadeInFilter, setMadeInFilter] = useState([]);
  const [ColorFilter, setColorFilter] = useState([]);
  const [ProtectionLevelFilter, setProtectionLevelFilter] = useState([]);
  const [EyeshadowEffectFilter, setEyeshadowEffectFilter] = useState([]);
  const [FormulaFilter, setFormulaFilter] = useState([]);
  const [CountryFilter, setCountryFilter] = useState([]);
  const [HairTypeFilter, setHairTypeFilter] = useState([]);
  const [BrushMaterialFilter, setBrushMaterialFilter] = useState([]);
  const [SkinTypeFilter, setSkinTypeFilter] = useState([]);
  const [AgeFilter, setAgeFilter] = useState([]);
  ///
  const { CategoryName } = useParams();
  const priceRanges = [
    { label: `${t("profile.Less")} 50 ₪`, min: 0, max: 50 },
    { label: "50 - 100 ₪", min: 50, max: 100 },
    { label: "100 - 250 ₪", min: 100, max: 250 },
    { label: "250 - 500 ₪", min: 250, max: 500 },
    { label: "500 - 750 ₪", min: 500, max: 750 },
    { label: "750 - 1000 ₪", min: 750, max: 1000 },
    { label: "1000 - 5000 ₪", min: 1000, max: 5000 },
    { label: `${t("profile.Morethan")} 5000 ₪`, min: 5000, max: Infinity },
  ];
  const handlePriceRangeCheckboxChange = (range) => {
    // If the range is already selected, deselect it; otherwise, select it
    if (selectedPriceRange?.label === range.label) {
      setSelectedPriceRange(null); // Deselect
      setCustomMinPrice(""); // Reset custom price inputs
      setCustomMaxPrice("");
      applyFilters(
        BrandsFilter,
        GenderFilter,
        TopNoteFilter,
        ProductTypeFilter,
        ClassficationFilter,
        ProductPropertiesFilter,
        ScentTypeFilter,
        HeartNoteFilter,
        BaseNoteFilter,
        IngredientsFilter,
        SpecialCertificatesFilter,
        VolumeFilter,
        MadeInFilter,
        ColorFilter,
        ProductPropertiesFilter,
        EyeshadowEffectFilter,
        FormulaFilter,
        CountryFilter,
        HairTypeFilter,
        BrushMaterialFilter,
        SkinTypeFilter,
        AgeFilter,
        0,
        Infinity
      ); // Apply filters with no range
    } else {
      setSelectedPriceRange(range); // Select the range
      setCustomMinPrice(range.min === Infinity ? "" : range.min); // Update inputs
      setCustomMaxPrice(range.max === Infinity ? "" : range.max);
      applyFilters(
        BrandsFilter,
        GenderFilter,
        TopNoteFilter,
        ProductTypeFilter,
        ClassficationFilter,
        ProductPropertiesFilter,
        ScentTypeFilter,
        HeartNoteFilter,
        BaseNoteFilter,
        IngredientsFilter,
        SpecialCertificatesFilter,
        VolumeFilter,
        MadeInFilter,
        ColorFilter,
        ProductPropertiesFilter,
        EyeshadowEffectFilter,
        FormulaFilter,
        CountryFilter,
        HairTypeFilter,
        BrushMaterialFilter,
        SkinTypeFilter,
        AgeFilter,
        range.min,
        range.max
      ); // Apply filters with selected range
    }
  };
  const handleCustomPriceChange = (type, value) => {
    const numericValue = parseFloat(value) || null;

    if (type === "min") {
      setCustomMinPrice(numericValue);
      applyFilters(
        BrandsFilter,
        GenderFilter,
        TopNoteFilter,
        ProductTypeFilter,
        ClassficationFilter,
        ProductPropertiesFilter,
        ScentTypeFilter,
        HeartNoteFilter,
        BaseNoteFilter,
        IngredientsFilter,
        SpecialCertificatesFilter,
        VolumeFilter,
        MadeInFilter,
        ColorFilter,
        ProductPropertiesFilter,
        EyeshadowEffectFilter,
        FormulaFilter,
        CountryFilter,
        HairTypeFilter,
        BrushMaterialFilter,
        SkinTypeFilter,
        AgeFilter,
        numericValue || 0,
        parseFloat(customMaxPrice) || Infinity
      );
    } else if (type === "max") {
      setCustomMaxPrice(numericValue);
      applyFilters(
        BrandsFilter,
        GenderFilter,
        TopNoteFilter,
        ProductTypeFilter,
        ClassficationFilter,
        ProductPropertiesFilter,
        ScentTypeFilter,
        HeartNoteFilter,
        BaseNoteFilter,
        IngredientsFilter,
        SpecialCertificatesFilter,
        VolumeFilter,
        MadeInFilter,
        ColorFilter,
        ProductPropertiesFilter,
        EyeshadowEffectFilter,
        FormulaFilter,
        CountryFilter,
        HairTypeFilter,
        BrushMaterialFilter,
        SkinTypeFilter,
        AgeFilter,
        parseFloat(customMinPrice) || 0,
        numericValue || Infinity
      );
    }
  };

  //Dont Show !!!!
  //---
  const ProductPropertiesArray = [
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
  ];
  const FindProductProperties = ProductPropertiesArray.find(
    (value) => value === Number(CategoryName)
  );
  //---
  const GenderArray = [
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
  ];

  const FindGender = GenderArray.find(
    (value) => value === Number(CategoryName)
  );
  //---

  const IngredientsArray = [
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
  ];

  const FindIngredients = IngredientsArray.find(
    (value) => value === Number(CategoryName)
  );

  //--------------
  const VolumeArray = [
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
  ];

  const FindVolume = VolumeArray.find(
    (value) => value === Number(CategoryName)
  );
  //--------------
  //--------------
  const MadeInArray = [...Array.from({ length: 15 }, (v, i) => 8000 + i)];

  const FindMadeIn = MadeInArray.find(
    (value) => value === Number(CategoryName)
  );
  //--------------
  //--------------
  const ColorArray = [
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
    ...Array.from({ length: 20 }, (v, i) => 1000 + i),
  ];

  const FindColor = ColorArray.find((value) => value === Number(CategoryName));
  //--------------
  //--------------
  const CountryArray = [
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
    ...Array.from({ length: 20 }, (v, i) => 1000 + i),
  ];

  const FindCountry = CountryArray.find(
    (value) => value === Number(CategoryName)
  );
  //--------------

  //End dont Show !!!!

  //Show Only in
  //---------------------------------
  const ScentTypeArray = [...Array.from({ length: 20 }, (v, i) => 1000 + i)];

  const FindScentType = ScentTypeArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const TopNoteArray = [
    ...Array.from({ length: 20 }, (v, i) => 1000 + i),
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
  ];

  const FindTopNote = TopNoteArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const HeartNoteArray = [...Array.from({ length: 20 }, (v, i) => 1000 + i)];

  const FindHeartNote = HeartNoteArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const BaseNoteArray = [...Array.from({ length: 20 }, (v, i) => 1000 + i)];

  const FindBaseNote = BaseNoteArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const ProtectionLevelArray = [
    ...Array.from({ length: 55 }, (v, i) => 2000 + i),
  ];

  const FindProtectionLevel = ProtectionLevelArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const EyeshadowEffectArray = [
    ...Array.from({ length: 55 }, (v, i) => 2000 + i),
  ];

  const FindEyeshadowEffect = EyeshadowEffectArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------
  //---------------------------------
  const FormulaArray = [...Array.from({ length: 55 }, (v, i) => 2000 + i)];

  const FindFormula = FormulaArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const HairTypeArray = [
    ...Array.from({ length: 42 }, (v, i) => 3000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
  ];

  const FindHairType = HairTypeArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------
  //---------------------------------
  const BrushMaterialArray = [
    ...Array.from({ length: 42 }, (v, i) => 3000 + i),
  ];

  const FindBrushMaterial = BrushMaterialArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const SkinTypeArray = [
    ...Array.from({ length: 41 }, (v, i) => 4000 + i),
    ...Array.from({ length: 58 }, (v, i) => 5000 + i),
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
  ];

  const FindSkinType = SkinTypeArray.find(
    (value) => value === Number(CategoryName)
  );
  //---------------------------------

  //---------------------------------
  const AgeArray = [
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
  ];

  const FindAge = AgeArray.find((value) => value === Number(CategoryName));
  //---------------------------------

  //End show Only in
  const filterStateMap = {
    BrandsFilter: {
      state: BrandsFilter,
      setState: setBrandsFilter,
    },
    GenderFilter: {
      state: GenderFilter,
      setState: setGenderFilter,
    },
    TopNoteFilter: {
      state: TopNoteFilter,
      setState: setTopNoteFilter,
    },
    ProductTypeFilter: {
      state: ProductTypeFilter,
      setState: setProductTypeFilter,
    },
    ClassficationFilter: {
      state: ClassficationFilter,
      setState: setClassficationFilter,
    },
    ProductPropertiesFilter: {
      state: ProductPropertiesFilter,
      setState: setProductPropertiesFilter,
    },
    ScentTypeFilter: {
      state: ScentTypeFilter,
      setState: setScentTypeFilter,
    },
    HeartNoteFilter: {
      state: HeartNoteFilter,
      setState: setHeartNoteFilter,
    },
    BaseNoteFilter: {
      state: BaseNoteFilter,
      setState: setBaseNoteFilter,
    },
    IngredientsFilter: {
      state: IngredientsFilter,
      setState: setIngredientsFilter,
    },
    SpecialCertificatesFilter: {
      state: SpecialCertificatesFilter,
      setState: setSpecialCertificatesFilter,
    },
    VolumeFilter: {
      state: VolumeFilter,
      setState: setVolumeFilter,
    },
    MadeInFilter: {
      state: MadeInFilter,
      setState: setMadeInFilter,
    },
    ColorFilter: {
      state: ColorFilter,
      setState: setColorFilter,
    },
    ProtectionLevelFilter: {
      state: ProtectionLevelFilter,
      setState: setProtectionLevelFilter,
    },
    EyeshadowEffectFilter: {
      state: EyeshadowEffectFilter,
      setState: setEyeshadowEffectFilter,
    },
    FormulaFilter: {
      state: FormulaFilter,
      setState: setFormulaFilter,
    },
    CountryFilter: {
      state: CountryFilter,
      setState: setCountryFilter,
    },
    HairTypeFilter: {
      state: HairTypeFilter,
      setState: setHairTypeFilter,
    },
    BrushMaterialFilter: {
      state: BrushMaterialFilter,
      setState: setBrushMaterialFilter,
    },
    SkinTypeFilter: {
      state: SkinTypeFilter,
      setState: setSkinTypeFilter,
    },

    AgeFilter: {
      state: AgeFilter,
      setState: setAgeFilter,
    },
    // Add other filters here as needed, following the same pattern
  };

  const handleCheckboxChangeForAll = (filterType, id) => {
    const filter = filterStateMap[filterType];
    if (!filter) return;

    const updatedFilter = filter.state.map((checkbox) => {
      return checkbox.id === id
        ? { ...checkbox, checked: !checkbox.checked }
        : checkbox;
    });
    filter.setState(updatedFilter);
    let foundObject = updatedFilter.find((item) => item.id === id);
    setTheObject((prevState) => {
      const updatedObject = {
        ...prevState, // Spread the existing properties
        id: id,
        filter: filterType,
      };

      setItems((prevItems) => {
        // Check if an item with the same id and filter already exists
        const exists = prevItems.some(
          (item) => item.id === id && item.filter === filterType
        );
        // If it exists, remove it; otherwise, add it
        return exists
          ? prevItems.filter(
              (item) => !(item.id === id && item.filter === filterType)
            )
          : [...prevItems, updatedObject];
      });
      return updatedObject;
    });
    //sendData(updatedObject);
    foundObject = "";

    // Apply all filters dynamically
    applyFilters(
      filterType === "BrandsFilter" ? updatedFilter : BrandsFilter,
      filterType === "GenderFilter" ? updatedFilter : GenderFilter,
      filterType === "TopNoteFilter" ? updatedFilter : TopNoteFilter,
      filterType === "ProductTypeFilter" ? updatedFilter : ProductTypeFilter,
      filterType === "ClassficationFilter"
        ? updatedFilter
        : ClassficationFilter,
      filterType === "ProductPropertiesFilter"
        ? updatedFilter
        : ProductPropertiesFilter,
      filterType === "ScentTypeFilter" ? updatedFilter : ScentTypeFilter,
      filterType === "HeartNoteFilter" ? updatedFilter : HeartNoteFilter,
      filterType === "BaseNoteFilter" ? updatedFilter : BaseNoteFilter,
      filterType === "IngredientsFilter" ? updatedFilter : IngredientsFilter,
      filterType === "SpecialCertificatesFilter"
        ? updatedFilter
        : SpecialCertificatesFilter,
      filterType === "VolumeFilter" ? updatedFilter : VolumeFilter,
      filterType === "MadeInFilter" ? updatedFilter : MadeInFilter,
      filterType === "ColorFilter" ? updatedFilter : ColorFilter,
      filterType === "ProtectionLevelFilter"
        ? updatedFilter
        : ProtectionLevelFilter,
      filterType === "EyeshadowEffectFilter"
        ? updatedFilter
        : EyeshadowEffectFilter,
      filterType === "FormulaFilter" ? updatedFilter : FormulaFilter,
      filterType === "CountryFilter" ? updatedFilter : CountryFilter,
      filterType === "HairTypeFilter" ? updatedFilter : HairTypeFilter,
      filterType === "BrushMaterialFilter"
        ? updatedFilter
        : BrushMaterialFilter,
      filterType === "SkinTypeFilter" ? updatedFilter : SkinTypeFilter,
      filterType === "AgeFilter" ? updatedFilter : AgeFilter,

      // Add more filters here as needed
      parseFloat(customMinPrice) || 0,
      parseFloat(customMaxPrice) || Infinity
    );
  };

  const [ShowApply, setShowApply] = useState(false);
  const [showTop, setshowTop] = useState([]);
  const [showTop2, setshowTop2] = useState([]);

  // Function to send data to the parent
  const sendData = (MyAllSelected) => {
    //sendDataToParent(MyAllSelected);
  };

  const ClearButton = (value) => {
    setShowTopSection(true);
    onToggle(true);
    sendPricingToParent("", "");
    setSelectedPriceRange(null); // Deselect
    setCustomMinPrice(""); // Reset custom price inputs
    setCustomMaxPrice("");
    //handleToggleFromChild(false);
    groupAndSetFilter(ProductsDataWithoutDub2, "brand", setBrandsFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "gender", setGenderFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "topNote", setTopNoteFilter);
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "productType",
      setProductTypeFilter
    );
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "classfication",
      setClassficationFilter
    );
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "productProperties",
      setProductPropertiesFilter
    );
    groupAndSetFilter(ProductsDataWithoutDub2, "scentType", setScentTypeFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "heartNote", setHeartNoteFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "baseNote", setBaseNoteFilter);
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "ingredients",
      setIngredientsFilter
    );
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "specialCertificates",
      setSpecialCertificatesFilter
    );
    groupAndSetFilter(ProductsDataWithoutDub2, "volume", setVolumeFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "madeIn", setMadeInFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "color", setColorFilter);
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "protectionLevel",
      setProtectionLevelFilter
    );
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "eyeshadowEffect",
      setEyeshadowEffectFilter
    );
    groupAndSetFilter(ProductsDataWithoutDub2, "formula", setFormulaFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "country", setCountryFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "hairType", setHairTypeFilter);
    groupAndSetFilter(
      ProductsDataWithoutDub2,
      "brushMaterial",
      setBrushMaterialFilter
    );
    groupAndSetFilter(ProductsDataWithoutDub2, "skinType", setSkinTypeFilter);
    groupAndSetFilter(ProductsDataWithoutDub2, "age", setAgeFilter);
    setItems([]);
    //handleClick();
    setProductsDataWithoutDub(ProductsDataWithoutDub2);
  };
  // Apply Filters for Products
  const applyFilters = (
    updatedBrands,
    updatedGenders,
    updatedTopNotes,
    updatedProductTypes,
    updatedClassfications,
    updatedProductProperties,
    updatedScentTypeFilter,
    updatedHeartNoteFilter,
    updatedBaseNoteFilter,
    updatedIngredientsFilter,
    updatedSpecialCertificatesFilter,
    updatedVolumeFilter,
    updatedMadeInFilter,
    updatedColorFilter,
    updatedProtectionLevelFilter,
    updatedEyeshadowEffectFilter,
    updatedFormulaFilter,
    updatedCountryFilter,
    updatedHairTypeFilter,
    updatedBrushMaterialFilter,
    updatedSkinTypeFilter,
    updatedAgeFilter,
    minPrice,
    maxPrice
  ) => {
    // const getSelectedValues = (items, key) =>
    //   items.filter((item) => item.checked).map((item) => item[key]);
    const getSelectedValues = (items, key) => {
      const selectedValues = items
        .filter((item) => item.checked)
        .map((item) => item[key]);
      return selectedValues;
    };

    const selectedBrands = getSelectedValues(updatedBrands, "brand");
    const selectedGenders = getSelectedValues(updatedGenders, "gender");
    const selectedTopNotes = getSelectedValues(updatedTopNotes, "topNote");
    const selectedProductType = getSelectedValues(
      updatedProductTypes,
      "productType"
    );
    const selectedClassifications = getSelectedValues(
      updatedClassfications,
      "classfication"
    );
    const selectedProductProperties = getSelectedValues(
      updatedProductProperties,
      "productProperties"
    );
    const selectedScentTypeFilter = getSelectedValues(
      updatedScentTypeFilter,
      "scentType"
    );
    const selectedHeartNoteFilter = getSelectedValues(
      updatedHeartNoteFilter,
      "heartNote"
    );
    const selectedBaseNote = getSelectedValues(
      updatedBaseNoteFilter,
      "baseNote"
    );
    const selectedIngredientsFilter = getSelectedValues(
      updatedIngredientsFilter,
      "ingredients"
    );
    const selectedSpecialCertificatesFilter = getSelectedValues(
      updatedSpecialCertificatesFilter,
      "specialCertificates"
    );
    const selectedVolumeFilter = getSelectedValues(
      updatedVolumeFilter,
      "volume"
    );
    const selectedMadeInFilter = getSelectedValues(
      updatedMadeInFilter,
      "madeIn"
    );
    const selectedColorFilter = getSelectedValues(updatedColorFilter, "color");
    const selectedProtectionLevelFilter = getSelectedValues(
      updatedProtectionLevelFilter,
      "protectionLevel"
    );
    const selectedEyeshadowEffectFilter = getSelectedValues(
      updatedEyeshadowEffectFilter,
      "color"
    );
    const selectedFormulaFilter = getSelectedValues(
      updatedFormulaFilter,
      "formula"
    );
    const selectedCountryFilter = getSelectedValues(
      updatedCountryFilter,
      "country"
    );
    const selectedHairTypeFilter = getSelectedValues(
      updatedHairTypeFilter,
      "hairType"
    );
    const selectedBrushMaterialFilter = getSelectedValues(
      updatedBrushMaterialFilter,
      "brushMaterial"
    );
    const selectedSkinTypeFilter = getSelectedValues(
      updatedSkinTypeFilter,
      "skinType"
    );
    const selectedAgeFilter = getSelectedValues(updatedAgeFilter, "age");

    // Combine all selected arrays into one
    const allSelected = [
      selectedBrands,
      selectedGenders,
      selectedTopNotes,
      selectedProductType,
      selectedClassifications,
      selectedProductProperties,
      selectedScentTypeFilter,
      selectedHeartNoteFilter,
      selectedBaseNote,
      selectedIngredientsFilter,
      selectedSpecialCertificatesFilter,
      selectedVolumeFilter,
      selectedMadeInFilter,
      selectedColorFilter,
      selectedProtectionLevelFilter,
      selectedEyeshadowEffectFilter,
      selectedFormulaFilter,
      selectedCountryFilter,
      selectedHairTypeFilter,
      selectedBrushMaterialFilter,
      selectedSkinTypeFilter,
      selectedAgeFilter,
    ];
    //setFilterArray(allSelected);
    sendData(allSelected);
    setshowTop(allSelected);
    const allEmpty = allSelected.every((arr) => arr.length === 0);
    setshowTop2(allEmpty);
    if (allEmpty && minPrice === 0 && maxPrice === Infinity) {
      setShowTopSection(true);
      onToggle(true);
    } else {
      setShowTopSection(false);
      onToggle(false);
    }

    const filteredProducts = ProductsDataWithoutDub2.filter((item) => {
      const productBrand = item.brand.split(",").map((tn) => tn.trim());

      const productGender = item.gender.split(",").map((tn) => tn.trim());

      const productTopNotes = item.topNote.split(",").map((tn) => tn.trim());
      const productProductType = item.productType
        .split(",")
        .map((tn) => tn.trim());

      const productClassfications = item.classfication
        .split(",")
        .map((tn) => tn.trim());
      const productProductProperties = item.productProperties
        .split(",")
        .map((tn) => tn.trim());

      const productScentTypeFilter = item.scentType
        .split(",")
        .map((tn) => tn.trim());
      const productHeartNoteFilter = item.heartNote
        .split(",")
        .map((tn) => tn.trim());

      const productBaseNoteFilter = item.baseNote
        .split(",")
        .map((tn) => tn.trim());

      const productIngredientsFilter = item.ingredients
        .split(",")
        .map((tn) => tn.trim());

      const productSpecialCertificatesFilter = item.specialCertificates
        .split(",")
        .map((tn) => tn.trim());

      const productVolumeFilter = item.volume.split(",").map((tn) => tn.trim());

      const productMadeInFilter = item.madeIn.split(",").map((tn) => tn.trim());

      const productColorFilter = item.color.split(",").map((tn) => tn.trim());

      const productProtectionLevelFilter = item.protectionLevel
        .split(",")
        .map((tn) => tn.trim());

      const productEyeshadowEffectFilter = item.eyeshadowEffect
        .split(",")
        .map((tn) => tn.trim());

      const productFormulaFilter = item.formula
        .split(",")
        .map((tn) => tn.trim());

      const productCountryFilter = item.country
        .split(",")
        .map((tn) => tn.trim());

      const productHairTypeFilter = item.hairType
        .split(",")
        .map((tn) => tn.trim());
      const productBrushMaterialFilter = item.brushMaterial
        .split(",")
        .map((tn) => tn.trim());
      const productSkinTypeFilter = item.skinType
        .split(",")
        .map((tn) => tn.trim());

      const productAgeFilter = item.age.split(",").map((tn) => tn.trim());

      // const matchesBrand =
      //   selectedBrands.length === 0 || selectedBrands.includes(item.brand);

      // const matchesGender =
      //   selectedGenders.length === 0 || selectedGenders.includes(item.gender);

      const matchesBrand =
        selectedGenders.length === 0 ||
        productGender.some((gender) => selectedGenders.includes(gender));

      const matchesGender =
        selectedBrands.length === 0 ||
        productBrand.some((gender) => selectedBrands.includes(gender));

      const matchesTopNote =
        selectedTopNotes.length === 0 ||
        productTopNotes.some((topNote) => selectedTopNotes.includes(topNote));

      const matchesProductType =
        selectedProductType.length === 0 ||
        productProductType.some((topNote) =>
          selectedProductType.includes(topNote)
        );

      const matchesClassfication =
        selectedClassifications.length === 0 ||
        productClassfications.some((topNote) =>
          selectedClassifications.includes(topNote)
        );

      const matchesProductProperties =
        selectedProductProperties.length === 0 ||
        productProductProperties.some((topNote) =>
          selectedProductProperties.includes(topNote)
        );
      const matchesScentTypeFilter =
        selectedScentTypeFilter.length === 0 ||
        productScentTypeFilter.some((topNote) =>
          selectedScentTypeFilter.includes(topNote)
        );

      const matchesHeartNoteFilter =
        selectedHeartNoteFilter.length === 0 ||
        productHeartNoteFilter.some((heartNote) =>
          selectedHeartNoteFilter.includes(heartNote)
        );

      const matchesBaseNoteFilter =
        selectedBaseNote.length === 0 ||
        productBaseNoteFilter.some((baseNote) =>
          selectedBaseNote.includes(baseNote)
        );

      const matchesIngredientsFilter =
        selectedIngredientsFilter.length === 0 ||
        productIngredientsFilter.some((baseNote) =>
          selectedIngredientsFilter.includes(baseNote)
        );

      const matchesSpecialCertificatesFilter =
        selectedSpecialCertificatesFilter.length === 0 ||
        productSpecialCertificatesFilter.some((specialCertificates) =>
          selectedSpecialCertificatesFilter.includes(specialCertificates)
        );

      const matchesVolumeFilter =
        selectedVolumeFilter.length === 0 ||
        productVolumeFilter.some((volume) =>
          selectedVolumeFilter.includes(volume)
        );

      const matchesMadeInFilter =
        selectedMadeInFilter.length === 0 ||
        productMadeInFilter.some((volume) =>
          selectedMadeInFilter.includes(volume)
        );

      const matchesColorFilter =
        selectedColorFilter.length === 0 ||
        productColorFilter.some((volume) =>
          selectedColorFilter.includes(volume)
        );

      const matchesProtectionLevelFilter =
        selectedProtectionLevelFilter.length === 0 ||
        productProtectionLevelFilter.some((volume) =>
          selectedProtectionLevelFilter.includes(volume)
        );

      const matchesEyeshadowEffectFilter =
        selectedEyeshadowEffectFilter.length === 0 ||
        productEyeshadowEffectFilter.some((volume) =>
          selectedEyeshadowEffectFilter.includes(volume)
        );

      const matchesFormulaFilter =
        selectedFormulaFilter.length === 0 ||
        productFormulaFilter.some((volume) =>
          selectedFormulaFilter.includes(volume)
        );

      const matchesCountryFilter =
        selectedCountryFilter.length === 0 ||
        productCountryFilter.some((volume) =>
          selectedCountryFilter.includes(volume)
        );

      const matchesHairTypeFilter =
        selectedHairTypeFilter.length === 0 ||
        productHairTypeFilter.some((volume) =>
          selectedHairTypeFilter.includes(volume)
        );
      const matchesBrushMaterialFilter =
        selectedBrushMaterialFilter.length === 0 ||
        productBrushMaterialFilter.some((volume) =>
          selectedBrushMaterialFilter.includes(volume)
        );

      const matchesSkinTypeFilter =
        selectedSkinTypeFilter.length === 0 ||
        productSkinTypeFilter.some((volume) =>
          selectedSkinTypeFilter.includes(volume)
        );

      const matchesAgeFilter =
        selectedAgeFilter.length === 0 ||
        productAgeFilter.some((volume) => selectedAgeFilter.includes(volume));

      const matchesPrice = item.price >= minPrice && item.price < maxPrice;
      handleClick2(minPrice, maxPrice);

      return (
        matchesBrand &&
        matchesGender &&
        matchesTopNote &&
        matchesPrice &&
        matchesProductType &&
        matchesClassfication &&
        matchesProductProperties &&
        matchesScentTypeFilter &&
        matchesHeartNoteFilter &&
        matchesBaseNoteFilter &&
        matchesIngredientsFilter &&
        matchesSpecialCertificatesFilter &&
        matchesVolumeFilter &&
        matchesMadeInFilter &&
        matchesColorFilter &&
        matchesProtectionLevelFilter &&
        matchesEyeshadowEffectFilter &&
        matchesFormulaFilter &&
        matchesCountryFilter &&
        matchesHairTypeFilter &&
        matchesBrushMaterialFilter &&
        matchesSkinTypeFilter &&
        matchesAgeFilter
      );
    });
    filteredProducts.length === ProductsDataWithoutDub2.length
      ? ShowApplyFunc(false)
      : ShowApplyFunc(true);
    setProductsDataWithoutDub(filteredProducts);
  };

  const ShowApplyFunc = (value) => {
    setShowApply(value);
  };
  /////// For Mobile

  const toggleDrawer = (newOpen) => () => {
    setOpen3(newOpen);
  };
  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  /////// End for Mobile
  const FilterSection = ({
    title,
    isOpen,
    toggleFilter,
    filterData,
    onChange,
    labelKey,
    countKey,
  }) => {
    return (
      <div
        style={{
          width: MyWidth <= 1024 ? "100%" : "80%",
          marginBottom: "16px",
          paddingLeft: "2%",
          paddingRight: "2%",
        }}
      >
        {/* Section Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 10,
          }}
        >
          <p style={{ fontWeight: "600", margin: 0, fontSize: 16 }}>{title}</p>
          <img
            src={isOpen ? minusImage1 : plusImage1}
            alt={isOpen ? "Collapse" : "Expand"}
            style={{ width: 16, height: 16, cursor: "pointer" }}
            onClick={toggleFilter}
          />
        </div>

        {isOpen && (
          <div style={{ maxHeight: "250px", overflowY: "auto" }}>
            {filterData.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
                onClick={() => {
                  setTheObject((prevState) => {
                    const updatedObject = {
                      ...prevState, // Spread the existing properties
                      name: item[labelKey], // Add the new Name property
                    };
                    return updatedObject;
                  });
                }}
              >
                <Checkbox
                  icon={
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        border: "1.4px solid #a3a3a3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 1,
                      }}
                    />
                  }
                  checkedIcon={
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        border: "1.4px solid #a3a3a3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 1,
                      }}
                    >
                      <Box
                        sx={{ width: 8, height: 8, backgroundColor: "black" }}
                      />
                    </Box>
                  }
                  checked={item.checked}
                  onChange={() => onChange(item.id)}
                  sx={{ padding: 0 }}
                />
                {i18n.resolvedLanguage === "en" ? <></> : <>&nbsp;</>}
                <a style={{ fontSize: 13 }}>
                  {item[labelKey]} ({item[countKey]}) <span>{item.label}</span>
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const TheFilters = () => {
    return (
      <div
        style={{
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        <div
          style={{
            marginBottom: "16px",
          }}
        ></div>
        <FilterSection
          title={t("filters.Brand")}
          isOpen={hideBrandFilter}
          toggleFilter={() => setHideBrandFilter(!hideBrandFilter)}
          filterData={BrandsFilter}
          onChange={(id) => handleCheckboxChangeForAll("BrandsFilter", id)}
          labelKey="brand"
          countKey="times"
        />

        <FilterSection
          title={t("filters.ProductType")}
          isOpen={hideProductTypeFilter}
          toggleFilter={() => setHideProductTypeFilter(!hideProductTypeFilter)}
          filterData={ProductTypeFilter}
          onChange={(id) => handleCheckboxChangeForAll("ProductTypeFilter", id)}
          labelKey="productType"
          countKey="times"
        />
        <FilterSection
          title={t("filters.Classification")}
          isOpen={hideClassfication}
          toggleFilter={() => setHideClassfication(!hideClassfication)}
          filterData={ClassficationFilter}
          onChange={(id) =>
            handleCheckboxChangeForAll("ClassficationFilter", id)
          }
          labelKey="classfication"
          countKey="times"
        />
        {FindProductProperties ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.ProductProperties")}
              isOpen={hideProductProperties}
              toggleFilter={() =>
                setHideProductProperties(!hideProductProperties)
              }
              filterData={ProductPropertiesFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("ProductPropertiesFilter", id)
              }
              labelKey="productProperties"
              countKey="times"
            />
          </>
        )}
        {FindGender ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Gender")}
              isOpen={hideGenderFilter}
              toggleFilter={() => setHideGenderFilter(!hideGenderFilter)}
              filterData={GenderFilter}
              onChange={(id) => handleCheckboxChangeForAll("GenderFilter", id)}
              labelKey="gender"
              countKey="times"
            />
          </>
        )}

        {FindScentType ? (
          <>
            <FilterSection
              title={t("filters.ScentType")}
              isOpen={hideScentType}
              toggleFilter={() => setHideScentType(!hideScentType)}
              filterData={ScentTypeFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("ScentTypeFilter", id)
              }
              labelKey="scentType"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindTopNote ? (
          <>
            <FilterSection
              title={t("filters.TopNote")}
              isOpen={hideTopNoteFilter}
              toggleFilter={() => setHideTopNoteFilter(!hideTopNoteFilter)}
              filterData={TopNoteFilter}
              onChange={(id) => handleCheckboxChangeForAll("TopNoteFilter", id)}
              labelKey="topNote"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindHeartNote ? (
          <>
            <FilterSection
              title={t("filters.HeartNote")}
              isOpen={hideHeartNote}
              toggleFilter={() => setHideHeartNote(!hideHeartNote)}
              filterData={HeartNoteFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("HeartNoteFilter", id)
              }
              labelKey="heartNote"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindBaseNote ? (
          <>
            <FilterSection
              title={t("filters.BaseNote")}
              isOpen={hideBaseNote}
              toggleFilter={() => setHideBaseNote(!hideBaseNote)}
              filterData={BaseNoteFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("BaseNoteFilter", id)
              }
              labelKey="baseNote"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindIngredients ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Ingredients")}
              isOpen={hideIngredients}
              toggleFilter={() => setHideIngredients(!hideIngredients)}
              filterData={IngredientsFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("IngredientsFilter", id)
              }
              labelKey="ingredients"
              countKey="times"
            />
          </>
        )}

        <FilterSection
          title={t("filters.SpecialCertificates")}
          isOpen={hideSpecialCertificates}
          toggleFilter={() =>
            setHideSpecialCertificates(!hideSpecialCertificates)
          }
          filterData={SpecialCertificatesFilter}
          onChange={(id) =>
            handleCheckboxChangeForAll("SpecialCertificatesFilter", id)
          }
          labelKey="specialCertificates"
          countKey="times"
        />

        {FindVolume ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Volume")}
              isOpen={hideVolume}
              toggleFilter={() => setHideVolume(!hideVolume)}
              filterData={VolumeFilter}
              onChange={(id) => handleCheckboxChangeForAll("VolumeFilter", id)}
              labelKey="volume"
              countKey="times"
            />
          </>
        )}

        {FindMadeIn ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.MadeIn")}
              isOpen={hideMadeIn}
              toggleFilter={() => setHideMadeIn(!hideMadeIn)}
              filterData={MadeInFilter}
              onChange={(id) => handleCheckboxChangeForAll("MadeInFilter", id)}
              labelKey="madeIn"
              countKey="times"
            />
          </>
        )}

        {FindColor ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Color")}
              isOpen={hideColor}
              toggleFilter={() => setHideColor(!hideColor)}
              filterData={ColorFilter}
              onChange={(id) => handleCheckboxChangeForAll("ColorFilter", id)}
              labelKey="color"
              countKey="times"
            />
          </>
        )}
        {FindProtectionLevel ? (
          <>
            <FilterSection
              title={t("filters.ProtectionLevel")}
              isOpen={hideProtectionLevel}
              toggleFilter={() => setHideProtectionLevel(!hideProtectionLevel)}
              filterData={ProtectionLevelFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("ProtectionLevelFilter", id)
              }
              labelKey="protectionLevel"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindEyeshadowEffect ? (
          <>
            <FilterSection
              title={t("filters.EyeshadowEffect")}
              isOpen={hideEyeshadowEffect}
              toggleFilter={() => setHideEyeshadowEffect(!hideEyeshadowEffect)}
              filterData={EyeshadowEffectFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("EyeshadowEffectFilter", id)
              }
              labelKey="eyeshadowEffect"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindFormula ? (
          <>
            <FilterSection
              title={t("filters.Formula")}
              isOpen={hideFormula}
              toggleFilter={() => setHideFormula(!hideFormula)}
              filterData={FormulaFilter}
              onChange={(id) => handleCheckboxChangeForAll("FormulaFilter", id)}
              labelKey="formula"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindCountry ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Country")}
              isOpen={hideCountry}
              toggleFilter={() => setHideCountry(!hideCountry)}
              filterData={CountryFilter}
              onChange={(id) => handleCheckboxChangeForAll("CountryFilter", id)}
              labelKey="country"
              countKey="times"
            />
          </>
        )}
        {FindHairType ? (
          <>
            <FilterSection
              title={t("filters.HairType")}
              isOpen={hideHairType}
              toggleFilter={() => setHideHairType(!hideHairType)}
              filterData={HairTypeFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("HairTypeFilter", id)
              }
              labelKey="hairType"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindBrushMaterial ? (
          <>
            <FilterSection
              title={t("filters.BrushMaterial")}
              isOpen={hideBrushMaterial}
              toggleFilter={() => setHideBrushMaterial(!hideBrushMaterial)}
              filterData={BrushMaterialFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("BrushMaterialFilter", id)
              }
              labelKey="brushMaterial"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindSkinType ? (
          <>
            <FilterSection
              title={t("filters.SkinType")}
              isOpen={hideSkinType}
              toggleFilter={() => setHideSkinType(!hideSkinType)}
              filterData={SkinTypeFilter}
              onChange={(id) =>
                handleCheckboxChangeForAll("SkinTypeFilter", id)
              }
              labelKey="brushMaterial"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindAge ? (
          <>
            <FilterSection
              title={t("filters.Age")}
              isOpen={hideAge}
              toggleFilter={() => setHideAge(!hideAge)}
              filterData={AgeFilter}
              onChange={(id) => handleCheckboxChangeForAll("AgeFilter", id)}
              labelKey="age"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {/* Section Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 10,
            width: MyWidth <= 1024 ? "100%" : "80%",
            paddingLeft: "2%",
            paddingRight: "2%",
          }}
        >
          <p style={{ fontWeight: "600", margin: 0, fontSize: 16 }}>
            {t("filters.PriceRanges")}
          </p>
          <img
            src={hidePrice ? minusImage1 : plusImage1}
            alt={hidePrice ? "Collapse" : "Expand"}
            style={{ width: 16, height: 16, cursor: "pointer" }}
            onClick={() => {
              setHidePrice(!hidePrice);
            }}
          />
        </div>
        {hidePrice ? (
          <div
            style={{
              width: MyWidth <= 1024 ? "100%" : "80%",
              paddingLeft: "2%",
              paddingRight: "2%",
              marginBottom: "160px",
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {priceRanges.map((range, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    width: "50%",
                    boxSizing: "border-box",
                    cursor: "pointer", // Makes it look clickable
                    paddingBottom: 10,
                  }}
                  onClick={() => handlePriceRangeCheckboxChange(range)} // Handles the click
                >
                  <div />
                  <a
                    style={{
                      opacity: 0.5,
                      // opacity:
                      //   selectedPriceRange?.label === range.label ? 1 : 0.5,
                      fontSize: 14,
                    }}
                  >
                    {range.label}
                  </a>
                </div>
              ))}
            </div>
            <div>
              {/* Custom Price Inputs */}
              <div
                style={{
                  display: "flex",
                  width: "80%",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.From")}</a>
                  <input
                    style={{
                      width: "30%",
                      margin: 0,
                      border: "1px solid #d4d4d4",
                      height: 35,
                    }}
                    type="number"
                    value={customMinPrice}
                    onChange={(e) =>
                      handleCustomPriceChange("min", e.target.value)
                    }
                  />
                  <a style={{ fontSize: 14 }}>{t("profile.To")}</a>
                  <input
                    style={{
                      width: "30%",
                      margin: 0,
                      border: "1px solid #d4d4d4",
                      height: 35,
                    }}
                    type="number"
                    value={customMaxPrice}
                    onChange={(e) =>
                      handleCustomPriceChange("max", e.target.value)
                    }
                  />
                  <a style={{ fontSize: 20 }}>₪</a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  };
  if (MyWidth <= 1024) {
    return (
      <div>
        {/* <Button onClick={toggleDrawer(true)}>Open drawer</Button> */}
        <Drawer
          open={open3}
          //onClose={handleToggleFromChild(false)}
          PaperProps={{
            sx: { width: "100%" }, // Ensures full width and height
          }}
        >
          <div
            style={{
              paddingLeft: "2%",
              paddingRight: "2%",
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 20,
            }}
          >
            <a style={{ fontSize: 20, fontWeight: "500" }}>Filters</a>
            <div style={{}} onClick={() => handleToggleFromChild(false)}>
              <img
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 25, height: 25, cursor: "pointer" }}
              />
            </div>
          </div>
          {TheFilters()}
          {ShowApply ? (
            <div
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                color: "white",
                textAlign: "center",
                padding: "10px",
                zIndex: 1000, // Ensure it stays on top of other content

                backgroundColor: "white",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingLeft: "2%",
                  paddingRight: "2%",
                }}
              >
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "white",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "49%",
                    minWidth: 180,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    border: "1px solid black",
                  }}
                  onClick={() => {
                    ClearButton();
                    handleToggleFromChild(false);
                  }}
                >
                  <a style={{ fontSize: 14, color: "black" }}>
                    {t("profile.Clear")}
                  </a>
                </button>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "49%",
                    minWidth: 180,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                  }}
                  onClick={() => {
                    handleToggleFromChild(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Apply")}</a>
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </Drawer>
      </div>
    );
  } else {
    return <div>{TheFilters()}</div>;
  }
}
